import React from 'react';
import { PhoneIcon } from 'lucide-react';
import { LinkButton } from '../ui/Button';
import { company } from '../../data/site';
const nav = [{
  label: 'Opgaver',
  href: '#opgaver'
}, {
  label: 'Om LYKKEVÆRK',
  href: '#om'
}, {
  label: 'Kontakt',
  href: '#kontakt'
}];
export function Header() {
  return <header className="sticky top-0 z-50 border-b border-line/70 bg-canvas/90 backdrop-blur-md" data-id="element-155" data-mp="1fm0begi97qkj">
      <div className="mx-auto flex h-16 max-w-content items-center justify-between gap-6 px-5 md:h-20 lg:px-8" data-id="element-156" data-mp="1kllbwvd2o6zd">
        <a href="#top" aria-label="LYKKEVÆRK — til toppen" data-id="element-157" data-mp="1ol3x7s8t2k2q">
          <img src={company.logoWide} alt="LYKKEVÆRK" className="h-9 w-auto md:h-12" data-id="element-158" data-mp="1tlrn2alasuvd" />
        </a>

        <nav aria-label="Sektioner" className="hidden items-center gap-1 md:flex" data-id="element-159" data-mp="1ykcogdcadkle">
          {nav.map(item => <a key={item.href} href={item.href} className="rounded-full px-3.5 py-2 text-[15px] text-ink-soft transition-colors duration-200 ease-smooth hover:text-ink" data-id="element-160" data-mp="3vdo8qd16jl3v">
              {item.label}
            </a>)}
        </nav>

        <div className="flex items-center gap-2" data-id="element-161" data-mp="2bvnhvtwabtjn">
          <a href={company.phoneHref} className="inline-flex h-11 w-11 items-center justify-center rounded-full border border-line bg-white text-ink transition-colors duration-200 ease-smooth hover:border-ink/30 sm:hidden" aria-label={`Ring til LYKKEVÆRK på ${company.phone}`} data-id="element-162" data-mp="2buul9lr1ikf8">
            <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-163" data-mp="2umncpbqgnxku" />
          </a>
          <a href={company.phoneHref} className="hidden items-center gap-2 text-[15px] text-ink-soft transition-colors duration-200 ease-smooth hover:text-ink lg:inline-flex" data-id="element-164" data-mp="2ukkdc13f4s3g">
            <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-165" data-mp="2lobcqj3pfnfq" />
            {company.phone}
          </a>
          <LinkButton href="#kontakt" size="md" className="hidden sm:inline-flex" data-id="element-166" data-mp="1a6tj4cfu846x">
            Få et tilbud
          </LinkButton>
        </div>
      </div>
    </header>;
}